<template>
  <div>
    <b-button v-b-modal.Info variant="primary"> 會員資料 </b-button>

    <b-modal id="Info" title="會員資料">
      <template #modal-header>
        <h1 class="modal-title fs-5">會員資料</h1>
      </template>
      <div v-if="fboData">
        <p>FBO 編號: {{ fboData.fbo_id }}</p>
        <p>{{ current_month }}月代幣: {{ fboData.token_current }}</p>
        <p>{{ next_month }}月代幣: {{ fboData.token_next }}</p>
        <p>電郵地址: {{ fboData.email }}</p>
        <p>
          電話號碼: {{ fboData.international_phone_code }}
          {{ fboData.mobile }}
        </p>
        <p>等級: {{ fboData.level }}</p>
      </div>
      <div v-if="error_message">
        <ErrorDisplay :error_message="error_message"></ErrorDisplay>
      </div>
      <template #modal-footer="{ hide }">
        <b-button variant="secondary" @click="hide()">關閉</b-button>
        <b-button variant="danger" @click="handleLogout()">登出</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ErrorDisplay from "./ErrorDisplay.vue";

export default {
  data() {
    return {
      current_month: null,
      next_month: null,
      error_message: "",
    };
  },
  async created() {
    const date = new Date();
    this.current_month = date.getMonth() + 1;
    this.next_month = (this.current_month % 12) + 1;

    this.tabId = window.name || "Unknown Tab";
    this.currentFboId =
      localStorage.getItem(`fbo_id_${this.tabId}`) || "Not Found";
    await this.getFBOData(this.currentFboId);
    if (this.fboDataErrorMessage) {
      this.error_message = this.fboDataErrorMessage;
    }
  },
  computed: {
    ...mapGetters(["fboData", "fboDataErrorMessage"]),
  },
  methods: {
    ...mapActions(["getFBOData"]),
    async handleLogout() {
      const tabId = window.name;
      if (tabId) {
        localStorage.removeItem(`access_token_${tabId}`);
        localStorage.removeItem(`refresh_token_${tabId}`);
        localStorage.removeItem(`fbo_id_${tabId}`);
      }
      this.$router.push("/");
    },
  },
  components: {
    ErrorDisplay,
  },
};
</script>
